import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import FuxIcon from "@/components/FuxIcon";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-slate-950 text-slate-300">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-1.5">
              <FuxIcon className="size-7" color="#22d3ee" />
              <span className="font-display font-bold text-[21px] tracking-tight text-white">adsFUX</span>
            </Link>
            <p className="mt-6 text-sm leading-relaxed text-slate-400 max-w-md">
              Wir liefern die Vermarktungslogik für Ihren Fahrzeugbestand. Datenqualität,
              Feed-Ausspielung und SEO-Sichtbarkeit — als Service, nicht als Self-Serve-Tool.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
              <Link to="/audit" data-track="cta_click" data-cta="audit" data-location="footer" className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-white px-4 py-2 text-sm font-medium text-slate-900 transition-colors hover:bg-slate-100 sm:w-auto">
                Audit anfragen <ArrowUpRight className="size-4" />
              </Link>
              <Link to="/demo" data-track="cta_click" data-cta="demo" data-location="footer" className="inline-flex w-full items-center justify-center gap-2 rounded-md border border-slate-700 px-4 py-2 text-sm text-white hover:border-slate-500 sm:w-auto">
                Demo ansehen
              </Link>
            </div>
          </div>

          <FooterCol
            title="Service"
            links={[
              { label: "Daten-Audit", href: "/audit" },
              { label: "Feed-Aufbereitung", href: "/#feed-check" },
              { label: "SEO-Landingpages", href: "/#seo-landingpages" },
              { label: "Datenanreicherung", href: "/#leistungen" },
            ]}
          />
          <FooterCol
            title="Partner"
            links={[
              { label: "White-Label", href: "/white-label" },
              { label: "Agenturen", href: "/white-label" },
              { label: "Händlergruppen", href: "/#zielgruppen" },
              { label: "Projekte", href: "/#projekte" },
            ]}
          />
          <FooterCol
            title="Rechtliches"
            links={[
              { label: "Impressum", href: "/impressum" },
              { label: "Datenschutz", href: "/datenschutz" },
              { label: "Kontakt", href: "/audit" },
            ]}
          />
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-slate-800 pt-8 md:flex-row md:items-center md:justify-between">
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-slate-500">
            © {new Date().getFullYear()} adsFUX · Vehicle Data Service Provider
          </p>
          <div className="flex flex-col gap-2 text-xs font-mono uppercase tracking-[0.2em] text-slate-500 sm:flex-row sm:items-center sm:gap-4">
            <span className="inline-flex items-center gap-2">
              <span className="size-1.5 rounded-full bg-emerald-400 pulse-dot" />
              Status: Operativ
            </span>
            <span>v3.2 · Q1/2026</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div className="md:col-span-2">
      <p className="label-mono text-slate-500 mb-4">{title}</p>
      <ul className="space-y-2.5">
        {links.map((l) => (
          <li key={l.label}>
            <Link to={l.href} data-track="footer_link_click" data-label={l.label} className="text-sm text-slate-300 hover:text-white transition-colors">
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
